module.exports = __webpack_public_path__ + "static/media/Rubik-Light.79aa6004.ttf";